module.exports = __webpack_public_path__ + "img/public/SiteIcons/greatSuccess.svg?c37cc285";